import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsDevRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-dev',
	path: '/secure/ConfigureDevStatus.jspa',
	query: ['projectKey'],
};
